<template>
  <div class="thread-placeholder container">
    <template v-if="isFeed">
      <div class="mb-5 pb-4">
        <div class="d-flex align-items-center">
          <placeholder-rect
            width="52px"
            height="52px"
            class="mb-1 mt-1"
            round
          />
          <placeholder-rect
            width="120px"
            height="24px"
            class="ml-0 mb-1 mt-1"
            round
          />
        </div>
        <placeholder-rect width="65%" height="32px" class="mr-1 mb-1 mt-1" />
        <placeholder-rect width="100%" height="200px" class="mb-0" />
      </div>
      <div>
        <div class="d-flex align-items-center">
          <placeholder-rect
            width="52px"
            height="52px"
            class="mb-1 mt-1"
            round
          />
          <placeholder-rect
            width="120px"
            height="24px"
            class="ml-0 mb-1 mt-1"
            round
          />
        </div>
        <placeholder-rect width="65%" height="32px" class="mr-1 mb-1 mt-1" />
        <placeholder-rect width="100%" height="200px" class="mb-0" />
      </div>
    </template>
    <template v-else>
      <div class="d-flex">
        <placeholder-rect
          width="100px"
          height="32px"
          class=" pl-2 mt-3 mb-0"
          style="margin-left: 3.5rem"
        />
      </div>
      <div class="d-flex mt-0 mb-0">
        <placeholder-rect
          width="32px"
          height="32px"
          class="mr-1 mb-1 mt-1"
          round
        />
        <placeholder-rect width="170px" height="32px" class="ml-0 mb-1 mt-1" />
      </div>
      <div class="d-flex">
        <placeholder-rect
          width="100px"
          height="32px"
          class=" pl-2 mt-3 mb-0"
          style="margin-left: 3.5rem"
        />
      </div>
      <div class="d-flex">
        <placeholder-rect width="32px" height="32px" class="mr-1 my-1" round />
        <placeholder-rect width="160px" height="32px" class="ml-0 my-1" />
      </div>
      <div class="d-flex mt-2">
        <placeholder-rect width="32px" height="32px" class="mr-1 my-1" round />
        <placeholder-rect width="100px" height="32px" class="ml-0 my-1" />
      </div>
    </template>
  </div>
</template>

<script>
import PlaceholderRect from "@/components/PlaceholderRect"

export default {
  components: {
    PlaceholderRect
  },

  props: {
    isFeed: { type: Boolean, default: false }
  }
}
</script>
